/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestShipmentPackage
 */
export interface RequestShipmentPackage {
    /**
     * 
     * @type {number}
     * @memberof RequestShipmentPackage
     */
    boxCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestShipmentPackage
     */
    boxHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestShipmentPackage
     */
    boxLength?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestShipmentPackage
     */
    boxWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestShipmentPackage
     */
    boxWidth?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestShipmentPackage
     */
    shipNum?: string;
}

/**
 * Check if a given object implements the RequestShipmentPackage interface.
 */
export function instanceOfRequestShipmentPackage(value: object): value is RequestShipmentPackage {
    return true;
}

export function RequestShipmentPackageFromJSON(json: any): RequestShipmentPackage {
    return RequestShipmentPackageFromJSONTyped(json, false);
}

export function RequestShipmentPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestShipmentPackage {
    if (json == null) {
        return json;
    }
    return {
        
        'boxCount': json['box_count'] == null ? undefined : json['box_count'],
        'boxHeight': json['box_height'] == null ? undefined : json['box_height'],
        'boxLength': json['box_length'] == null ? undefined : json['box_length'],
        'boxWeight': json['box_weight'] == null ? undefined : json['box_weight'],
        'boxWidth': json['box_width'] == null ? undefined : json['box_width'],
        'shipNum': json['ship_num'] == null ? undefined : json['ship_num'],
    };
}

export function RequestShipmentPackageToJSON(json: any): RequestShipmentPackage {
    return RequestShipmentPackageToJSONTyped(json, false);
}

export function RequestShipmentPackageToJSONTyped(value?: RequestShipmentPackage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'box_count': value['boxCount'],
        'box_height': value['boxHeight'],
        'box_length': value['boxLength'],
        'box_weight': value['boxWeight'],
        'box_width': value['boxWidth'],
        'ship_num': value['shipNum'],
    };
}

